import { Competition } from '@/model';
import {
  GetTeamCompetitionResponse,
  PostTeamCompetitionResponse,
  PutTeamCompetitionResponse,
} from '@/services/response/competition';

export class CompetitionConverter {
  static toDomainFromGetResponse(response: GetTeamCompetitionResponse): Competition[] {
    return response.map(item => ({
      uuid: item.uuid,
      name: item.name,
      created_at: item.created_at,
      updated_at: item.updated_at,
    }));
  }

  static toDomainFromPostResponse(response: PostTeamCompetitionResponse): Competition {
    return {
      uuid: response.uuid,
      name: response.name,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutTeamCompetitionResponse): Competition {
    return {
      uuid: response.uuid,
      name: response.name,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
